import style from "./button.module.scss";

const Button = ({
  className,
  title,
  handleClick,
  type,
  isLoading,
  disabled,
  icon,
  id
}) => {
  return (
    <>
      <button
        className={`${style.btn} ${className}`}
        onClick={(e) => {
          handleClick && handleClick(e);
        }}
        id={id}
        type={type}
        disabled={disabled || isLoading || false}
        style={{ pointerEvents: isLoading || disabled ? "none" : "auto" }}
      >
        {icon && <img src={icon} alt={"button icon"} />}
        {title}
      </button>
    </>
  );
};

export default Button;
